<div class="au-dialog-container">
	<h2 class="au-dialog-title">{{ 'add_room' | translate }}</h2>
	<mat-icon mat-dialog-close matRipple class="close-icon">close</mat-icon>
	<div class="au-dialog-content">
		<form [formGroup]="form" class="au-forms">
			<mat-form-field hideRequiredMarker class="m-t-m">
				<input
					type="text"
					matInput
					formControlName="roomName"
					[placeholder]="'room_name' | translate"
				/>

				<mat-error>
					@if (roomNameControl.errors?.required) {
						<span>{{ 'required' | translate }}</span>
					}
				</mat-error>
			</mat-form-field>

			<mat-form-field hideRequiredMarker class="m-t-m">
				<mat-select formControlName="roomType" [placeholder]="'room_type' | translate">
					@for (type of roomTypes; track type) {
						<mat-option [value]="type.id">
							{{ roomTypeTranslationKeys[type.id] || type.id | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field hideRequiredMarker class="m-t-m" floatLabel="always">
				<mat-select formControlName="roomTenant" placeholder="{{ 'tenant' | translate }}">
					<mat-option value="">{{ 'no_tenant' | translate }}</mat-option>
					@for (type of availableTenants; track type) {
						<mat-option [value]="type.psId">
							{{ type?.name }}
						</mat-option>
					}
				</mat-select>
				@if (!availableTenants.length) {
					<mat-spinner class="spinner" diameter="20"></mat-spinner>
				}
			</mat-form-field>
		</form>
	</div>
</div>
<div class="action-buttons">
	<au-techno-btn class="cancel" [fullWidth]="true" mat-dialog-close
		>{{ 'cancel' | translate }}
	</au-techno-btn>
	<button
		type="submit"
		matRipple
		class="au-btn uppercase save-button"
		[disabled]="!form.valid"
		(click)="addApproved()"
	>
		{{ 'add' | translate }}
	</button>
</div>
